import React from 'react';
import Hero from '../components/Hero';
import BookCard from '../components/BookCard';
import FreeSample from '../components/FreeSample';
import Newsletter from '../components/Newsletter';
import { books } from '../data/mockBooks';
import { Sparkles } from 'lucide-react';

const HomePage = () => {
  const handleShareBook = (book) => {
    // Share book functionality - opens native share or copies link
    if (navigator.share) {
      navigator.share({
        title: book.title,
        text: book.description,
        url: book.amazonLink,
      });
    } else {
      navigator.clipboard.writeText(book.amazonLink);
    }
  };

  return (
    <div>
      <Hero />

      {/* Books Section */}
      <section id="books-section" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-orange-100 px-6 py-2 rounded-full mb-4">
              <Sparkles className="h-4 w-4 text-orange-500" />
              <span className="text-sm font-semibold text-orange-700 tracking-wide">
                OUR COLLECTION
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              Featured Puzzle Books
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore our carefully crafted word search puzzle books designed to challenge 
              your mind and provide endless entertainment.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {books.map((book) => (
              <BookCard key={book.id} book={book} onShare={handleShareBook} />
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-2 bg-white px-8 py-4 rounded-full shadow-lg">
              <span className="text-gray-600">All books available on</span>
              <span className="font-bold text-gray-900">Amazon</span>
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M.045 18.02c.072-.116.187-.124.348-.022 3.636 2.11 7.594 3.166 11.87 3.166 2.852 0 5.668-.533 8.447-1.595l.315-.14c.138 0 .225.062.27.179.044.107.033.213-.035.32-.39.46-1.094.639-2.108.639-3.95 0-7.574-1.013-10.87-3.04L.045 18.02zm22.193.022c.265-.297.479-.458.646-.481.168-.023.346.053.533.228.187.175.28.396.28.662 0 .226-.108.486-.326.777-.218.291-.486.437-.804.437-.168 0-.315-.056-.442-.168-.126-.112-.19-.256-.19-.43 0-.174.053-.342.161-.505l.142-.52z"/>
              </svg>
            </div>
          </div>
        </div>
      </section>

      <FreeSample />
      
      <Newsletter />
    </div>
  );
};

export default HomePage;
